import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { CurrentWork } from "@/components/CurrentWork";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { MarqueeStrip } from "@/components/Marquee";
import { Work } from "@/components/Work";
import { Clients } from "@/components/Clients";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-background text-foreground font-body">
      <div className="noise-overlay" aria-hidden="true" />
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(0,0,0,0.1)",
            color: "#111111",
            borderRadius: 0,
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <CurrentWork />
        <Manifesto />
        <Services />
        <MarqueeStrip />
        <Work />
        <Clients />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
